import { useState } from 'react';
import Banner from './components/Banner';
import EventDetails from './components/EventDetails';
import RSVPForm from './components/RSVPForm';
import SuccessMessage from './components/SuccessMessage';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorDialog from './components/ErrorDialog';
import { submitRSVP } from './utils/api';

export default function App() {
    const [formData, setFormData] = useState({
        name: '',
        numberOfGuests: '1',
        additionalInfo: ''
    });

    const [foodPreferences, setFoodPreferences] = useState(['vegetarian']);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [confirmationData, setConfirmationData] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'numberOfGuests') {
            const count = parseInt(value);
            const newPrefs = Array.from({ length: count }, (_, i) =>
                foodPreferences[i] || 'vegetarian'
            );
            setFoodPreferences(newPrefs);
        }
    };

    const handleFoodPrefChange = (index, value) => {
        const newPrefs = [...foodPreferences];
        newPrefs[index] = value;
        setFoodPreferences(newPrefs);
    };

    const handleSubmit = async () => {
        if (!formData.name.trim()) {
            setError('Please enter your name');
            return;
        }

        setLoading(true);
        setError(null);

        const result = await submitRSVP(formData, foodPreferences);

        if (result.success) {
            setConfirmationData(result.data);
            setSubmitted(true);
        } else {
            setError(result.error);
        }

        setLoading(false);
    };

    const handleReset = () => {
        setSubmitted(false);
        setError(null);
        setConfirmationData(null);
        setFormData({
            name: '',
            numberOfGuests: '1',
            additionalInfo: ''
        });
        setFoodPreferences(['vegetarian']);
    };

    const handleCloseError = () => {
        setError(null);
    };

    const handleRetry = () => {
        setError(null);
        handleSubmit();
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (submitted) {
        return <SuccessMessage onReset={handleReset} confirmationData={confirmationData} />;
    }

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 py-8 px-4">
                <div className="max-w-4xl mx-auto">
                    <Banner />
                    <EventDetails />
                    <div className="bg-white p-8 shadow-xl">
                        <RSVPForm
                            formData={formData}
                            foodPreferences={foodPreferences}
                            onFormChange={handleChange}
                            onFoodPrefChange={handleFoodPrefChange}
                            onSubmit={handleSubmit}
                        />
                    </div>
                    <Footer />
                </div>
            </div>

            <ErrorDialog
                error={error}
                onClose={handleCloseError}
                onRetry={handleRetry}
            />
        </>
    );
}